import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import * as React from 'react'
import { LoaderIcon } from '@/app/features/icons/Loader'
import { getDriverViolationsColumns } from '@/modules/drivers/constants/tables'
import { ViolationsListHeader } from './ViolationsListHeader'
import ViolationsListRow from './ViolationsListRow'
import { ViolationModel } from '@/app/models'
import FlexView from '@/modules/shared/components/FlexView'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
const ViolationsList = ({
  violations,
}: {
  violations: ReadonlyArray<ViolationModel>
}) => {
  const loading = useLoadingStore(selectLoading)
  const { t } = useLocalize()
  const columns = getDriverViolationsColumns(t)
  return (
    <section className="tw-h-fit tw-overflow-x-auto ">
      <div className="tw-relative tw-h-full">
        {loading ? (
          <div className="tw-grid tw-h-full tw-place-items-center">
            <LoaderIcon className="tw-w-16 tw-animate-spin" />
          </div>
        ) : violations.length > 0 ? (
          <>
            <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2 tw-pl-2">
              <ViolationsListHeader columns={columns} />
              <tbody>
                {violations.map((violation, index) => (
                  <ViolationsListRow
                    key={index}
                    index={index}
                    violation={violation}
                  />
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <>
            <FlexView vAlignContent="center" hAlignContent="center">
              <span style={{ color: '#97A2B3' }} className="text-xl tw-my-4">
                {t('driverModule.no-violations-for-day')}
              </span>
            </FlexView>
          </>
        )}
      </div>
    </section>
  )
}

export default ViolationsList
